
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectángulo 23","fill":"none","d":"M0 0h79v79H0z"}}),_c('g',{attrs:{"data-name":"Grupo 143","fill":"#6c757d"}},[_c('path',{attrs:{"data-name":"Trazado 17","d":"M23.227 59.088v1.764h32.491v-1.764a16.25 16.25 0 00-32.491 0zm14.44-12.22v6.929h3.61v-6.929a12.522 12.522 0 0110.7 10.456H26.966a12.522 12.522 0 0110.701-10.456z"}}),_c('path',{attrs:{"data-name":"Trazado 18","d":"M68.063 25.055a7.055 7.055 0 10-7.055 7.055 7.063 7.063 0 007.055-7.055zm-7.055 3.527a3.527 3.527 0 113.527-3.527 3.531 3.531 0 01-3.526 3.527z"}}),_c('path',{attrs:{"data-name":"Trazado 19","d":"M61.008 32.371a8.828 8.828 0 00-8.818 8.818v5.291h17.754v-5.291a8.913 8.913 0 00-8.936-8.818zm5.409 10.582h-10.7v-1.764a5.3 5.3 0 015.291-5.291 5.422 5.422 0 015.409 5.291z"}}),_c('path',{attrs:{"data-name":"Trazado 20","d":"M24.99 25.055a7.055 7.055 0 10-7.055 7.055 7.063 7.063 0 007.055-7.055zm-7.055 3.527a3.527 3.527 0 113.527-3.527 3.531 3.531 0 01-3.526 3.527z"}}),_c('path',{attrs:{"data-name":"Trazado 21","d":"M26.754 41.189a8.877 8.877 0 00-17.754 0v5.291h17.754zm-3.527 1.764h-10.7v-1.764a5.422 5.422 0 015.409-5.291 5.3 5.3 0 015.291 5.291z"}}),_c('path',{attrs:{"data-name":"Trazado 22","d":"M51.818 30.346a12.346 12.346 0 10-12.346 12.346 12.36 12.36 0 0012.346-12.346zm-12.346 8.818a8.818 8.818 0 118.818-8.818 8.828 8.828 0 01-8.817 8.818z"}}),_c('path',{attrs:{"data-name":"Trazado 23","d":"M43.516 25.697l-5.808 5.808-2.28-2.28-2.494 2.494 4.774 4.774 8.3-8.3z"}})])])
          )
        }
      }
    